// extracted by mini-css-extract-plugin
module.exports = {"caro":"Carousel_caro__3_038","im":"Carousel_im__1SbNt","phone":"Carousel_phone__RCcCM","laptop":"Carousel_laptop__wmHqE"};